// extracted by mini-css-extract-plugin
export default {"editorWrapper":"ProductPage_editorWrapper__EQJtd","buttonIcon":"ProductPage_buttonIcon__oWG+-"};